<template>
  <div class="test-report">
    <div class="title">{{$t('verification')}}</div>
    <div class="title1">{{$t('verification_title')}}</div>
    <div class="cur-p">
      <div style="text-align:center">
        <img :src="verList[curIndex].bigImgUrl" alt="" :class="{'imgWidth0':curIndex=== 0,'imgWidth1':curIndex=== 1}">
        <div v-if="curIndex == 1" class="img-text">{{verList[curIndex].imgtext}}</div>
      </div>
      <div v-if="curIndex === 2 || curIndex === 4 || curIndex === 5" class="img-box1" style="text-align:center">
        <div style="margin-right:20px;">
          <img :src="verList[curIndex].image1" />
          <div class="img-des">{{verList[curIndex].imgtext1}}</div>
        </div>
        <div>
          <img :src="verList[curIndex].image2" />
          <div class="img-des">{{verList[curIndex].imgtext2}}</div>
        </div>
      </div>
      <div v-if="verList[curIndex].title" class="cur-title">{{verList[curIndex].title}}</div>
      <div class="cur-des">{{verList[curIndex].description}}</div>
    </div>
    <div class="box-content">
      <div class="left-icon">
        <img src="../assets/verification/left-icon.png" alt="" @click="goLeft">
      </div>
      <div class="box">
        <div class="box-item" v-for="(item, index) in curList" :key="index">
          <img :src="item.imgUrl" alt="">
        </div>
      </div>
      <div class="right-icon">
        <img src="../assets/verification/right-icon.png" alt="" @click="goRight">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      curIndex:0,
      verList: [
        {
          title: this.$t('verification1.title'),
          description: this.$t('verification1.description'),
          bigImgUrl:require('../assets/verification/img1.png'),
          imgUrl:require('../assets/verification/list-img1.png')
        },
        {
          title: this.$t('verification2.title'),
          description: this.$t('verification2.description'),
          bigImgUrl:require('../assets/verification/img2.png'),
          imgUrl:require('../assets/verification/list-img2.png'),
          imgtext:this.$t('verification2.imgtext'),
        },
        {
          title:"",
          description: this.$t('verification2.des'),
          image1: require('../assets/verification/img2-1.png'),
          image2: require('../assets/verification/img2-2.png'),
          imgUrl:require('../assets/verification/list-img3.png'),
          imgtext1:this.$t('verification2.imgtext1'),
          imgtext2:this.$t('verification2.imgtext2'),
        },
        {
          title: this.$t('verification3.title'),
          description: this.$t('verification3.description'),
          bigImgUrl:require('../assets/verification/img3.png'),
          imgUrl:require('../assets/verification/list-img4.png'),
        },
        {
          title: this.$t('verification4.title'),
          description: this.$t('verification4.description'),
          // bigImgUrl:require('../assets/verification/img4.png'),
          imgUrl:require('../assets/verification/list-img5.png'),
          image1: require('../assets/verification/img4-1.png'),
          image2: require('../assets/verification/img4-2.png'),
        },
        {
          title: this.$t('verification5.title'),
          description: this.$t('verification5.description'),
          imgUrl:require('../assets/verification/list-img6.png'),
          image1: require('../assets/verification/img5-1.png'),
          image2: require('../assets/verification/img5-2.png'),
        },
      ],
    };
  },
  computed:{
    curList() {
      const array = this.verList;
      const index = this.curIndex;
      const length = array.length;
      const result = [];
      
      // 需要获取4个元素
      for (let i = 0; i < 4; i++) {
        // 计算实际位置：(当前索引 + 1 + i) % 数组长度
        const pos = (index + 1 + i) % length;
        result.push(array[pos]);
      }
      
      return result;
      
    },
  },
  methods:{
    goRight() {
      if(this.curIndex == 5) {
        this.curIndex = 0
      }else {
        this.curIndex++
      }
    },
    goLeft() {
      if(this.curIndex == 0) {
        this.curIndex = 5
      }else {
        this.curIndex--
      }
    }
  }
};
</script>

<style scoped lang="scss">
.test-report {
  color: white;
  margin-top: 72px;
  padding: 0 16vw;
  .title {
    font-weight: bold;
    font-size: 46px;
    color: #FFFFFF;
    margin-left: -1vw;
  }
  .title1 {
    font-size: 16px;
    color: #FFFFFF;
    margin-top: 114px;
  }
  .cur-p {
    margin-top: 43px;
    background: rgba(45, 122, 254,0.19);
    border-radius: 10px;
    padding: 25px 25px 46px 25px;
    img {
      margin: auto;
      &.imgWidth0 {
        width: 100%;
      }
      &.imgWidth1 {
        width: 300px;
      }
    }
    .cur-title {
      margin-top: 100px;
    }
    .cur-des {
      margin-top: 28px;
      text-indent: 2em;
      line-height: 30px;
    }
    .img-text {
      font-weight: 400;
      font-size: 20px;
      color: #fff;
      margin-top: 35px;
    }
    .img-box1 {
      text-align: center;
      margin-top: 70px;
      display: flex;
      justify-content: center;
      align-items: center;
      .img-des {
        font-weight: 400;
        font-size: 20px;
        color: #FFFFFF;
        margin-top: 35px;
      }
    }
  }
  .box-content {
    display: flex;
    margin: 0 -44px;
    margin-top: 28px;
    align-items: center;
    .left-icon {
      margin-right: 22px;
      cursor: pointer;
    }
    .right-icon {
      margin-left: 22px;
      cursor: pointer;
    }
  }
  .box {
    flex: 1;
    list-style-type: none;
    padding: 0;
    display: flex;
    justify-content: space-between;
    
    .box-item {
      border-radius: 5px;
      width: calc(25% - 15px);
      margin-right: 8px;
      img {
        width: 100%;
      }
    }
  }
}
</style>